import clx from "classnames";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import AppIcon from "./AppIcon";
import Spinner from "./Spinner";

const _MODES = {
  primary: "bg-primary text-primary-fg hover:bg-primary/90 focus:ring-primary",
  "light-primary": "bg-primary/70 hover:bg-primary/80 focus:ring-primary text-primary-fg",
  success: "bg-success hover:bg-success/90 focus:ring-success text-success-fg",
  "light-success": "bg-card text-success border border-success hover:text-primary-fg hover:bg-success focus:ring-success",
  warning: "bg-warning hover:bg-warning/90 focus:ring-warning text-warning-fg",
  "light-warning": "bg-card text-warning border border-warning hover:text-primary-fg hover:bg-warning focus:ring-warning",
  danger: "bg-destructive text-destructive-fg hover:bg-destructive/90 focus:ring-destructive",
  "light-danger": "bg-card hover:bg-destructive focus:ring-destructive text-destructive hover:text-destructive-fg",
  light: "border bg-card hover:bg-bg-dark focus:ring-muted text-fg",
  icon: "rounded-sm focus:ring-0 text-fg hover:bg-bg-dark",
};

const _SIZES = {
  sm: "h-8 px-3 text-sm",
  md: "h-12",
};

export default function AppButton({
  loading,
  disabled = false,
  title,
  tooltip = "",
  mode = "light",
  icon,
  iconClassname,
  iconPosition = "left",
  size = "md",
  href,
  className = "",
  onClick = () => {},
}) {
  const intl = useIntl();

  const navigate = useNavigate();

  const _disabled = disabled || loading;

  const renderIcon = () => {
    if (!icon && !loading) return null;
    return loading ? <Spinner className="w-6 h-6" /> : <AppIcon code={icon} className={clx("w-6 h-6", iconClassname)} />;
  };

  return (
    <button
      disabled={disabled || loading}
      onClick={() => {
        if (href) return navigate(href);
        else return onClick();
      }}
      title={tooltip}
      className={`flex items-center justify-center py-2 px-4 rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
        _MODES[mode]
      } ${_SIZES[size]} ${_disabled ? "opacity-75 pointer-events-none" : "cursor-pointer"} ${className}`}
    >
      {iconPosition === "left" && renderIcon()}
      {title && (
        <span
          className={clx("", {
            "ml-2": (icon || loading) && iconPosition === "left",
            "mr-2": (icon || loading) && iconPosition === "right",
          })}
        >
          {intl.formatMessage({ id: title ?? "-" })}
        </span>
      )}
      {iconPosition === "right" && renderIcon()}
    </button>
  );
}
